import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";

import { CharacterCountPluginProps } from "../types";
import { getNormalizedTextLength } from "../utils/textContent";

/**
 * Reports character count via onCountChange. Display is handled by RichTextEditor
 * in a shared footer row with the error message.
 */
export const CharacterCountPlugin = ({
  onCountChange
}: CharacterCountPluginProps): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        onCountChange?.(getNormalizedTextLength());
      });
    });
  }, [editor, onCountChange]);

  return null;
};
